import { useField } from "formik"
import React from "react"
import { Checkbox } from "primereact/checkbox"
import { Skeleton } from "primereact/skeleton"

//Style
import styles from "../../../../styles/Form-Inputs.module.css"
import refStyles from "../../../../styles/Referrals.module.css"

/* interface Props {
    name: string;
    label?: string;
    disabled?: boolean;
} */

export default function RefCheckBox(props) {
  const [field, meta] = useField(props.name)

  const getCheckbox = () => {
    if (props.isInitialLoad) {
      return <Skeleton height="42px" width="42px" />
    } else {
      return (
        <Checkbox
          {...field}
          {...props}
          checked={field.value}
          className={refStyles.checkBox}
        />
      )
    }
  }

  const getLabel = () => {
    if (props.isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return <label>{props.label}</label>
    }
  }

  return (
    <div className={styles.field}>
      {getLabel()}
      {props.helpText ? (
        <div>
          <small style={{ color: "gray" }}>{props.helpText}</small>
        </div>
      ) : null}
      <div>
        {getCheckbox()}
        {meta.touched && meta.error ? (
          <label id={`${props.name}-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        ) : null}
      </div>
    </div>
  )
}
